/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GdprConsent } from './gdprConsent';
import { MotorRisk } from './motorRisk';
import { Participant } from './participant';
import { PartnershipCard } from './partnershipCard';
import { PaymentMethod } from './paymentMethod';
import { PremiumDetail } from './premiumDetail';
import { PremiumDiff } from './premiumDiff';
import { PremiumDiscountAmn } from './premiumDiscountAmn';
import { PremiumPaymentModality } from './premiumPaymentModality';
import { RelatedProjectPolicy } from './relatedProjectPolicy';
import { RfsDiscount } from './rfsDiscount';

export interface MotorProject {
  /**
   * Numerical reference that MAPFRE assigns to each project to identify it
   */
  projectQuoteId?: string;
  /**
   * Numerical reference that MAPFRE gives to client to identify his project
   */
  projectQuoteNumber?: string;
  effectiveDate?: Date;
  /**
   * Project capture Date
   */
  captureDate?: Date;
  /**
   * Project state
   */
  projectStatusCode?: MotorProject.ProjectStatusCodeEnum;
  /**
   * Business branch code. Eg: Seconda Casa, Casa Digital, Mutuo Protteto, Affito Sereno
   */
  branchCode?: string;
  /**
   * Business branch Description. Eg: Seconda Casa, Casa Digital, Mutuo Protteto, Affito Sereno
   */
  readonly branchDesc?: string;
  /**
   * UserId associated with the project
   */
  userId?: string;
  /**
   * Numerical reference that MAPFRE assigns to each simulation to identify it
   */
  simulationId?: string;
  /**
   * Flag that indicates if it has a policy
   */
  policyExistsInd?: boolean;
  /**
   * Numerical reference that MAPFRE assigns to each insurance contract to identify it
   */
  policyId?: string;
  policyVersion?: string;
  /**
   * Identification of the action. The names of the shares by entity will be typified and indicated in the list of the entity's own shares
   */
  actionId?: string;
  /**
   * Numerical reference that MAPFRE assigns to each project version to identify it
   */
  version?: string;
  channel?: string;
  consents?: GdprConsent;
  motorRisks?: Array<MotorRisk>;
  partnershipCard?: Array<PartnershipCard>;
  policyCancellationDate?: Date;
  premiumDetail?: PremiumDetail;
  premiumDiff?: PremiumDiff;
  premiumDiscountAmn?: PremiumDiscountAmn;
  discountRFS?: RfsDiscount;
  premiumPaymentModalities?: Array<PremiumPaymentModality>;
  premiumPaymentModality?: PremiumPaymentModality;
  projectParticipants?: Array<Participant>;
  relatedPolicies?: Array<RelatedProjectPolicy>;
  paymentMethod?: PaymentMethod;
  mip?: MotorProject.MipEnum;
  messageCondizioniDiAcquistoId?: string;
  namedInsuredEqualOwner?: boolean;
  namedInsuredEqualDriver?: boolean;
  ownerEqualDriver?: boolean;
  bestOfferProjectQuoteId?: string;
  bestOfferVersion?: string;
  rateFromDate?: Date;
}
export namespace MotorProject {
  export type ProjectStatusCodeEnum = 'Quoted' | 'SCADUTO' | 'NON_VALIDO' | 'APPENDICE' | 'Draft' | 'Pending';
  export const ProjectStatusCodeEnum = {
    Quoted: 'Quoted' as ProjectStatusCodeEnum,
    SCADUTO: 'SCADUTO' as ProjectStatusCodeEnum,
    NONVALIDO: 'NON_VALIDO' as ProjectStatusCodeEnum,
    APPENDICE: 'APPENDICE' as ProjectStatusCodeEnum,
    Draft: 'Draft' as ProjectStatusCodeEnum,
    Pending: 'Pending' as ProjectStatusCodeEnum,
  };
  export type MipEnum = 'post' | 'e_mail';
  export const MipEnum = {
    Post: 'post' as MipEnum,
    EMail: 'e_mail' as MipEnum,
  };
}
